import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  sellerAccountLogin,
  sellerAccountRegistration,
} from "../../Redux/Actions/sellerAction";

const SellerForm1 = ({ onNext }) => {
  const [displaySignup, setDisplaySignup] = useState("hidden");
  const [displaySignin, setDisplaySignin] = useState("block");
  const dispatch = useDispatch();
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const displayAction = () => {
    if (displaySignup === "hidden") {
      setDisplaySignup("block");
      setDisplaySignin("hidden");
    } else {
      setDisplaySignup("hidden");
      setDisplaySignin("block");
    }
  };

  const loginHandle = () => {
    const sellerLoginData = {
      email: email,
      password: password,
    };

    dispatch(sellerAccountLogin(sellerLoginData));
    onNext();
  };

  const registrationHandle = () => {
    const sellerRegistrationData = {
      fullname: fullName,
      email: email,
      password: password,
      phone: phone,
    };

    dispatch(sellerAccountRegistration(sellerRegistrationData));
    onNext();
  };

  return (
    <div className="w-full px-2 md:px-0 mt-12">
      <h1 className="text-center font-bold text-lg mb-4">
        Apna App seller form
      </h1>
      <div className="md:w-1/4 w-auto  md:mx-auto border rounded-md border-gray-300 shadow-lg px-3 py-3">
        {/* singin form */}
        <div className={`${displaySignin}`}>
          <div className="mb-3">
            <label
              for="email"
              className="block mb-1 text-sm font-semibold text-gray-900 "
            >
              Email (opstional)
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
              placeholder="name@flowbite.com"
              required=""
            />
          </div>
          <div className="mb-3">
            <label
              for="password"
              className="block mb-1 text-sm font-semibold text-gray-900 "
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
              placeholder="************"
              required=""
            />
          </div>

          <button
            onClick={loginHandle}
            className="text-white bg-amber-500 hover:bg-amber-500/90 focus:ring-4 focus:outline-none font-medium rounded-sm shadow-sm text-sm w-full  px-5 py-2 mt-2 text-center "
          >
            Sign in
          </button>

          <div className="flex items-start mb-6 mt-6">
            <div className="flex items-center h-5">
              <input
                id="remember"
                type="checkbox"
                value=""
                className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
                required=""
              />
            </div>
            <label
              for="remember"
              className="ml-2 text-xs font-normal text-gray-900 "
            >
              Keep me signed in .{" "}
              <a href="" className=" text-blue-400 text-sm">
                Details
              </a>
            </label>
          </div>

          <div>
            <h1 className="text-center text-xs font-medium text-gray-800">
              New to Apna App ?
            </h1>
            <button
              type="submit"
              onClick={displayAction}
              className="text-jet bg-neutral-300 hover:bg-neutral-300 border shadow-sm   focus:outline-none font-medium rounded-sm text-sm w-full  px-5 py-2 mt-2 text-center "
            >
              Create a new account
            </button>
          </div>
        </div>

        {/* signup form  */}
        <div className={`${displaySignup}`}>
          <div className="mb-3">
            <label
              for="name"
              className="block mb-1 text-sm font-semibold text-gray-900 "
            >
              Your name
            </label>
            <input
              type="text"
              id="name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
              placeholder="username"
              required=""
            />
          </div>
          <div className="mb-3">
            <label
              for="mobileno"
              className="block mb-1 text-sm font-semibold text-gray-900 "
            >
              Mobile number
            </label>
            <input
              type="number"
              id="mobileno"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
              placeholder="91+ ....."
              required=""
            />
          </div>
          <div className="mb-3">
            <label
              for="email"
              className="block mb-1 text-sm font-semibold text-gray-900 "
            >
              Email (opstional)
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
              placeholder="name@flowbite.com"
              required=""
            />
          </div>
          <div className="mb-3">
            <label
              for="password"
              className="block mb-1 text-sm font-semibold text-gray-900 "
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block w-full px-2.5 py-2 placeholder-gray-400 "
              placeholder="************"
              required=""
            />
          </div>

          <div className="flex items-start mb-6">
            <div className="flex items-center h-5">
              <input
                id="remember"
                type="checkbox"
                value=""
                className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
                required=""
              />
            </div>
            <label
              for="remember"
              className="ml-2 text-xs font-normal text-gray-900 "
            >
              We will send you a text to verify your phone. Message or data rate
              may apply.
            </label>
          </div>
          <button
            onClick={registrationHandle}
            className="text-white bg-amber-500 hover:bg-amber-500/90 focus:ring-4 focus:outline-none font-medium rounded-sm text-sm w-full  px-5 py-2 text-center "
          >
            Submit
          </button>

          <div className="py-2">
            <h1 className="text-sm">
              Already have an account?{" "}
              <button
                onClick={displayAction}
                className="text-blue-400 text-sm "
              >
                sing in
              </button>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerForm1;
